import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  Widget,
  RuntimeEnumerationOption,
  FormEnumRadioWidget
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: [ModelFieldType.Enum],
    name: 'settlementMethodEnum',
    model: 'deli.aries.seller.SellerDistributionCreateOrderParam',
    widget: 'Radio'
  })
)
export class MyFormEnumFieldWidget extends FormEnumRadioWidget {
  @Widget.Reactive()
  protected get options(): RuntimeEnumerationOption[] {
    const options = super.options;

    // 代发订单隐藏结算方式为“铺货”的选项
    if (this.formData.orderType === 'DROPSHIPPING') {
      return options.filter((opt) => opt.name !== 'DISTRIBUTION_OF_GOODS');
    }

    return options;
  }
}
